// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Describes a log message that is sent to a remote logger.
 */
export type LogMessage = {
  message: string;
  logLevel: string;
};